import React, { useState } from "react";
import pic from "../../Assets/new.jpg";
import "../../../src/FlyingEnvelopes.css";

const FlyingText = ({ delay }) => (
  <div
    className="absolute right-0 bottom-0 opacity-0 transition-all duration-1000 ease-out flying-text"
    style={{
      animationDelay: `${delay}s`,
    }}
  >
    Send
  </div>
);

const InquirySection = () => {
  const [showAnimation, setShowAnimation] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "info", message: "Sending..." });

    try {
      const response = await fetch(
        "https://connectengagegrow.shop/ceg/Backend/send_inquiry.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
          credentials: "include",
        }
      );

      // Ensure that the response is in JSON format
      const data = await response.json();

      if (response.ok) {
        setStatus({ type: "success", message: "Message sent successfully!" });
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus({
          type: "error",
          message: data.error || "Failed to send message",
        });
      }
    } catch (error) {
      setStatus({ type: "error", message: "Failed to send message" });
    }
  };

  return (
    <div className="max-w-6xl mx-auto py-12">
      <div className="flex flex-col md:flex-row mx-4 md:mx-8 lg:gap-20">
        {/* Image Section */}
        <div className="w-full md:w-1/2">
          <div className="h-full md:h-[600px] rounded-2xl overflow-hidden md:mt-20 ">
            <img
              src={pic}
              alt="Pink roses in bloom"
              className="w-full h-full object-cover "
            />
          </div>
        </div>

        {/* Form Section */}
        <div className="w-full md:w-1/2 p-12 lg:p-16">
          <h1
            className="text-3xl text-center mb-12 tracking-widest text-gray-800"
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            <span className="mr-2">I</span>
            <span className="mr-2">N</span>
            <span className="mr-2">Q</span>
            <span className="mr-2">U</span>
            <span className="mr-2">I</span>
            <span className="mr-2">R</span>
            <span>E</span>
          </h1>

          <p
            className="text-center mb-12 text-gray-600 text-md"
            style={{
              fontFamily: "commuterssans-regular",
            }}
          >
            We'd love to hear from you! Please fill out the form below or send a
            note directly to{" "}
            <a
              href="mailto:sales@ceg.com"
              className="text-gray-800 hover:text-gray-600"
            >
              shop@ceg.com
            </a>
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First NAME"
                className="w-full border-b border-gray-200 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors text-md tracking-wider"
              />
            </div>
            <div>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="LAST NAME"
                className="w-full border-b border-gray-200 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors text-md tracking-wider"
              />
            </div>

            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="EMAIL ADDRESS"
                className="w-full border-b border-gray-200 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors text-md tracking-wider"
              />
            </div>

            <div>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="SUBJECT OF INQUIRY"
                className="w-full border-b border-gray-200 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors text-md tracking-wider"
              />
            </div>

            <div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Enter your message here."
                rows={4}
                className="w-full border-b border-gray-200 py-2 placeholder-gray-400 focus:outline-none focus:border-gray-400 transition-colors text-md resize-none"
              />
            </div>

            <div
              className="text-right relative"
              style={{
                fontFamily: "theimpressionist",
              }}
            >
              <button
                type="submit"
                className="text-[#734f3f] text-2xl font-light hover:text-gray-700 transition-colors italic relative "
                onMouseEnter={() => setShowAnimation(true)}
                onMouseLeave={() => setShowAnimation(false)}
              >
                Send
                {showAnimation && (
                  <>
                    <FlyingText delay={0} />
                    <FlyingText delay={0.2} />
                    <FlyingText delay={0.4} />
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default InquirySection;
